// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Headers
 */
/*
  Base Sizing
 */
/*
  Colors
 */
/*
  Border Radii Sizes
 */
/*
  Shadows
 */
/*
  Global Styles
 */
html {
  font-size: 10px;
}

/**
 * COODE Header Colors
 */
.chart_wrapper {
  background-color: #ffffff;
  width: 100%;
  overflow: hidden;
  margin-right: 15px;
  margin-left: 15px;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  padding: 25px;
}
.chart_wrapper .lastestChange h5 {
  color: #adadad;
  font-size: 1em;
}
.chart_wrapper .currency-wrapper {
  float: right;
  margin-right: 70px;
  margin-top: 35px;
}
@media (max-width: 767px) {
.chart_wrapper .currency-wrapper {
    margin-right: 0px;
}
}
@media (max-width: 450px) {
.chart_wrapper .currency-wrapper {
    margin-right: 0px;
    margin-top: 0px;
    float: left;
    margin-left: 10px;
}
}
.chart_wrapper .size-legend-pie {
  width: 450px;
}
@media (max-width: 1600px) {
.chart_wrapper .size-legend-pie {
    width: 430px;
}
}
@media (max-width: 1399px) {
.chart_wrapper .size-legend-pie {
    width: 415px;
}
}
.chart_wrapper .legend-title {
  margin-left: 64px;
  display: inline-block;
}
@media (max-width: 767px) {
.chart_wrapper .legend-title {
    margin-left: 5px;
}
}
.chart_wrapper .legend-budget-distribution {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  margin-top: 5px;
}
.chart_wrapper .legend-budget-distribution .dot-legend-budget-distribution {
  width: 14px;
  height: 14px;
  border-radius: 20px;
  border-color: #00b0ff;
  background-color: #00b0ff;
  display: flex;
  align-self: center;
  margin: 0 7px;
}
.chart_wrapper .legend-budget-distribution .text-legend {
  display: flex;
  align-self: center;
}
.chart_wrapper .legend-budget-distribution .dot-legend-budget-distribution.capex-color {
  border-color: #283593;
  background-color: #283593;
}
.chart_wrapper .legend-budget-distribution .box-legend {
  display: flex;
  flex-direction: row;
  height: 30px;
  border: 1px solid #00b0ff;
  border-radius: 20px;
  min-width: 90px;
  margin-right: 1.6rem;
}
.chart_wrapper .legend-budget-distribution .box-legend.capex-color {
  border-color: #283593;
}
.chart_wrapper .wrapper_date {
  border-bottom: 1px solid #d6d6d6;
  padding: 10px 0;
}
.chart_wrapper .wrapper_date h5 {
  color: #adadad;
  font-size: 1em;
}
.chart_wrapper h6 {
  color: #adadad;
}
.chart_wrapper .vertical-bar {
  border-left: 1px solid #d6d6d6;
  height: 100%;
  position: absolute;
  left: 95%;
  margin-left: -3px;
  top: 0;
}
.chart_wrapper .apexcharts-series.apexcharts-pie-series {
  cursor: pointer;
}
@media (max-width: 1399px) {
.chart_wrapper .vertical-bar {
    display: none;
}
}
@media (max-width: 575px) {
.chart_wrapper .apexcharts-legend-text {
    font-size: 1.28rem !important;
}
.chart_wrapper .apexcharts-legend {
    top: -5px !important;
    left: 180px !important;
}
}
.chart_wrapper .pui-chip-country {
  color: white;
  background-color: #0059a4;
}
.chart_wrapper .pui-chip-country .pui-chip__text {
  display: block;
  font-weight: bold;
}
.chart_wrapper .pui-chip-country + .pui-chip-country {
  margin-left: 10px;
}
#content {
  max-height: 350px;
}
a.button-edit:hover {
  text-decoration: none;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
